export default "__VITE_ASSET__DBFl_Io6__"